import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ProfileImageSignResponse } from './types';

type SignProfileImageUploadParams = {
  memberId: string;
  fileName: string;
  fileType: string;
};

export async function signProfileImageUpload({ memberId, fileName, fileType }: SignProfileImageUploadParams) {
  const url = `/web/studio/users/${memberId}/profile-image/sign`;

  const response = await api.executePostRequest<ObjectResponse<ProfileImageSignResponse>>(url, {
    file_name: fileName,
    file_type: fileType,
  });

  return response.data;
}
